import { render, staticRenderFns } from "./OverallAgencyScore.vue?vue&type=template&id=1f9c1f64&scoped=true"
import script from "./OverallAgencyScore.vue?vue&type=script&lang=js"
export * from "./OverallAgencyScore.vue?vue&type=script&lang=js"
import style0 from "./OverallAgencyScore.vue?vue&type=style&index=0&id=1f9c1f64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9c1f64",
  null
  
)

export default component.exports